export const ADD_CHARACTER = 'ADD_CHARACTER';
export const UPDATE_CONNECTED_CHARACTER = 'UPDATE_CONNECTED_CHARACTER';
export const ADD_CHARACTERS = 'ADD_CHARACTERS';
export const ADD_CHARACTER_CLASSES = 'ADD_CHARACTER_CLASSES';
export const REFRESH_CHARACTER = 'REFRESH_CHARACTER';
export const FOLLOW_CHARACTER = 'FOLLOW_CHARACTER';
export const UNFOLLOW_CHARACTER = 'UNFOLLOW_CHARACTER';
export const ADD_FOLLOWING_CHARACTERS = 'ADD_FOLLOWING_CHARACTERS';
